
import Characterization from "./components/characterization";

import Optimization from "./components/optimization";

import Score from "./components/score";

export function Results() {
  
  return (

    <div className="flex flex-col items-center">

      <Score />

      <Characterization />

      <Optimization />

    </div>

  )

}
